import React from 'react';
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

const Distribution = ({ distributionData }) => {
    // console.log(JSON.stringify(data));
    const uniqueKeys = distributionData ? distributionData.shift() : [];
    return (
        uniqueKeys ?.length > 1 ?
            <React.Fragment>
                <ResponsiveContainer width="100%" height={200}>
                    <BarChart data={distributionData}
                        margin={{ top: 10, right: 0, left: -25, bottom: 0 }}>
                        <XAxis dataKey="question" />
                        <YAxis />
                        <CartesianGrid strokeDasharray="3 3" />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey={uniqueKeys[0]} fill="#3367d6" />
                        <Bar dataKey={uniqueKeys[1]} fill="#ffc658" />
                    </BarChart>
                </ResponsiveContainer>
            </React.Fragment >
            : <React.Fragment></React.Fragment>
    );
};

export default Distribution;



// WEBPACK FOOTER //
// ./components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/Distribution.js